import { language, textHandler } from '../../../resources'
import se from './se.json'
import fi from './fi.json'
import dk from './dk.json'
import no from './no.json'

let strings = null

export const getTextErrors = () => {
  if (strings === null)
    strings = { se, fi, dk, no }[language]
  return textHandler.parse(strings, se)
}

export default (...args) => {
  if (strings === null)
    strings = { se, fi, dk, no }[language]
  return textHandler.getText(strings, args)
}